/* eslint-disable react/prop-types */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable max-len */
import React from 'react';

const InformationIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0008 0.300049C18.4625 0.300049 23.7008 5.53832 23.7008 12C23.7008 18.4618 18.4625 23.7001 12.0008 23.7001C5.53905 23.7001 0.300781 18.4618 0.300781 12C0.300781 5.53832 5.53905 0.300049 12.0008 0.300049ZM12.0008 1.70005C6.31225 1.70005 1.70078 6.31152 1.70078 12C1.70078 17.6886 6.31225 22.3 12.0008 22.3C17.6893 22.3 22.3008 17.6886 22.3008 12C22.3008 6.31152 17.6893 1.70005 12.0008 1.70005ZM13.3341 9.16672V15.8334H15.0008V17.5H10.0008V15.8334H11.6674L11.6668 10.8327L10.0008 10.8334V9.16672H13.3341ZM12.0841 5.00005C12.7745 5.00005 13.3341 5.55969 13.3341 6.25005C13.3341 6.9404 12.7745 7.50005 12.0841 7.50005C11.3938 7.50005 10.8341 6.9404 10.8341 6.25005C10.8341 5.55969 11.3938 5.00005 12.0841 5.00005Z"
        fill="black"
      />
    </svg>
  );
};

export default InformationIcon;
